<template>
    <div class="ManagementCenter">
        <div class="topWrap">
            <div class="box">
                <router-link to="/managementIndex/classHourManagement">学时管理</router-link>
                <router-link to="/managementIndex/creditManagement">学分管理</router-link>
                <router-link to="/managementIndex/courseManagement">课程管理</router-link>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {

    },
    components: {

    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .ManagementCenter .topWrap{
        display: none;
    }
}
@media screen and (min-width: 1029px) {
    .ManagementCenter{
        width: 100%;
        background-color: #fafafa;
        overflow: hidden;
        .topWrap{
            width: 100%;
            background-color: #fff;
            .box{
                width: 1200px;
                margin: 0 auto;
                line-height: 84px;
                a{
                    font-size: 15px;
                    color: #19191A;
                    margin-right: 70px;
                }
                .router-link-active{
                    color: #0061FE;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ManagementCenter/ManagementIndex.vue